import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import { ProtocolSectionHttpEditRequestModel } from './types';
import { Fetcher } from '../fetcher';
import { ProtocolSectionInDto } from 'shared/dtos/in/protocolSection';

export class ProtocolSectionRequestRunner implements IHttpRequestRunner {
  constructor(private fetcher: typeof Fetcher) {}

  async execute(
    request: ProtocolSectionHttpEditRequestModel
  ): Promise<ProtocolSectionInDto> {
    if (request.method !== 'PUT') {
      throw new Error(
        'ProtocolSectionRequestRunner only supports PUT method'
      );
    }

    const response = await this.fetcher.PUT(
      request.url,
      request.data.protocolSectionOutDto
    );

    return response as ProtocolSectionInDto;
  }
}
